<footer>

  <div itemscope="" itemtype="http://schema.org/Organization" class=”d-none”>
    <meta itemprop="name" content="EVLAND">
    <meta itemprop="telephone" content="+380668898990">
    <meta itemprop="email" content="info@ev.land">
    <meta itemprop="address" content="вулиця Газопровідна, 43, Київ, Украина" i18n-content>
    <meta itemprop="logo" content="https://ev.land/assets/images/logo-simple.svg">
    <meta itemprop="legalName" content="EVLAND">
    <link itemprop="url" href="https://ev.land" content="https://ev.land">
  </div>

  <div class="container">

    <div class="top-bar">

      <div class="row justify-content-sm-between align-items-center">

        <div class="col-auto mb-3 mb-lg-0">

          <a class="logo d-inline-block" routerLink="/">
            <img ngSrc="/assets/images/logo-with-label.svg" width="141" height="38" alt="Логотип EVLAND" i18n-alt />
          </a>

        </div>

        <div class="col col-sm-auto">

          <div class="hint" i18n><sup>*</sup> Ціни на сайті орієнтовні та не є публічною офертою, для отримання точної
            ціни зверніться до менеджерів.
          </div>

        </div>

      </div>

    </div>

    <div class="content">

      <div class="row">

        @for (group of contentLinkGroups; track group.label; let index = $index) {

          <div class="col-12 col-md-6 col-xl-3">

            @if (index > 0) {
              <div [class.d-xl-none]="!!index" class="delimiter"></div>
            }

            <div class="title">{{ group.label }}</div>

            <ul class="content-menu-list list-unstyled" itemscope itemtype="http://schema.org/SiteNavigationElement">

              @for (link of group.links; track link.label) {

                <li class="content-menu-list-item">

                  @if (link.href) {
                    <a [class.disabled]="link.disabled" [routerLink]="link.href"
                       [routerLinkActiveOptions]="{exact: link.href === '/'}" routerLinkActive="active"
                       class="content-menu-link" itemprop="url">
                      {{ link.label }}
                      <meta [content]="link.label" itemprop="name">
                    </a>
                  } @else {
                    <div (click)="onActionClick(link.action)" [class.disabled]="link.disabled"
                         class="content-menu-link">
                      {{ link.label }}
                    </div>
                  }

                </li>

              }

            </ul>

          </div>

        }

        <div class="col-md-6 col-xl-3">
          <div class="delimiter d-xl-none"></div>
          <div class="title" i18n>Контакти</div>
          <div class="mb-2">
            <a href="tel:+380668898990"
               class="phone-link d-inline-flex flex-row justify-content-start align-items-center">
              <mat-icon class="icon me-2" svgIcon="custom:vodafone"></mat-icon>
              <span class="label">+380 (66) 889 89 90</span>
            </a>
          </div>
          <div class="mb-2">
            <a href="tel:+380688898998"
               class="phone-link d-inline-flex flex-row justify-content-start align-items-center">
              <mat-icon class="icon me-2" svgIcon="custom:kyivstar"></mat-icon>
              <span class="label">+380 (68) 889 89 98</span>
            </a>
          </div>
          <div class="mb-2">
            <a href="tel:+380938898998"
               class="phone-link d-inline-flex flex-row justify-content-start align-items-center">
              <mat-icon class="icon me-2" svgIcon="custom:lifecell"></mat-icon>
              <span class="label">+380 (93) 889 89 98</span>
            </a>
          </div>
          <div class="mb-2">
            <a href="mailto:info@ev.land"
               class="phone-link email-link d-inline-flex flex-row justify-content-start align-items-center">
              <mat-icon class="icon me-2" svgIcon="sax:bulk-sms"></mat-icon>
              <span class="label">{{ 'info@ev.land' }}</span>
            </a>
          </div>
        </div>

        <div class="col-md-6 col-xl-3">
          <div class="title">Адреса та графік</div>

          <ul class="contacts-list list-unstyled">
            <li class="contacts-list-item d-flex flex-row align-items-center">
              <mat-icon svgIcon="sax:bulk-location" class="icon"></mat-icon>
              <a href="https://goo.gl/maps/tRYu75ihAjXazRxVA" target="_blank" class="label" i18n>вулиця Газопровідна,
                43, Київ, Україна</a>
            </li>
            <li class="contacts-list-item d-flex flex-row align-items-center">
              <mat-icon svgIcon="sax:bulk-clock-1" class="icon"></mat-icon>
              <div class="label d-inline-flex" i18n>Пн-Пт: 10:00-18:30 <br />Сб: 10:00-17:00 <br />Нд: Вихідний</div>
            </li>
          </ul>
        </div>

      </div>

    </div>

    <div class="chats-and-manager">

      <div class="row">

        <div class="col-md-6 col-xl-4 mb-4 mb-xl-0">

          <div class="title mb-3" i18n>Підпишіться на Telegram</div>

          <p class="description mb-3" i18n>Обмінюйтеся думками, порадами та досвідом з іншими ентузіастами. Створіть з нами
            майбутнє чистої мобільності!</p>

          <a href="https://t.me/chademoforchina" target="_blank" class="btn btn-telegram d-inline-flex flex-row justify-content-center align-items-center">
            <mat-icon class="icon me-2" svgIcon="social:telegram-inverted"></mat-icon>
            <span i18n>Підписатися</span>
          </a>
        </div>

        <div class="col-md-6 col-xl-4 mb-4 mb-xl-0">

          <div class="title mb-3" i18n>Підпишіться на Viber</div>

          <p class="description mb-3" i18n>Дізнається про надходження нових моделей автівок та вигідних пропозицій від наших
            партнерів першим.</p>

          <a href="https://invite.viber.com/?g2=AQAxXbbRQOHyE1Jnn5nskiaUR91VtNzgMBbLcOHkK7QC4ckyMo5NiPq7faLI%2Fq1r" target="_blank" class="btn btn-viber d-inline-flex flex-row justify-content-center align-items-center">
            <mat-icon class="icon me-2" svgIcon="social:viber"></mat-icon>
            <span i18n>Підписатися</span>
          </a>

        </div>

        <div class="col-xl-4">

          <div class="title mb-3" i18n>Ми готові допомогти</div>

          <p class="description mb-3" i18n>Маєте запитання щодо вибору авто чи фінансування? Наші експерти допоможуть знайти
            найкраще рішення!</p>

          <button (click)="openCallbackModal()" class="btn btn-consult btn-primary" i18n>Консультація</button>

        </div>

      </div>

    </div>

    <div class="bottom-bar">

      <div class="row flex-row justify-content-between align-items-center">

        <div class="col-12 col-md-auto">

          <ul class="important-links-list list-inline" itemscope itemtype="http://schema.org/SiteNavigationElement">

            @for (navLink of importantNavLinks; track navLink.label) {

              <li class="list-inline-item d-flex d-md-inline-flex">

                <a [routerLink]="navLink.href" [fragment]="navLink.fragment" class="important-link" itemprop="url">
                  {{ navLink.label }}
                </a>

              </li>

            }

          </ul>

        </div>

        <div class="col-12 col-md-auto">
          <div class="social-block d-inline-flex flex-row align-items-center">

            <div class="label d-none d-sm-inline-flex" i18n>Наші соціальні мережі</div>

            <ul class="social-links-list list-inline">

              @for (navLink of socialNavLinks; track navLink.label) {

                <li class="list-inline-item">

                  <a [href]="navLink.href" [title]="navLink.label" target="_blank" class="social-link d-inline-block">
                    <mat-icon [svgIcon]="navLink.icon" class="icon"></mat-icon>
                  </a>

                </li>

              }

            </ul>

          </div>

        </div>

      </div>

    </div>

  </div>

</footer>
